<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      formConfig: {},
    };
  },
  props: {
    propsObj: Object,
  },
  mounted() {
    this.params = { tastingPoolId: this.propsObj.row.id };
    this.getConfigList('tpm_wine_mixing_pool_detail');
  },
  methods: {

  },
};
</script>
